<template>
  <div class="main-content">
    <!-- 列表页面 -->
    <el-form :inline="true" :model="searchForm" class="form-content">
      <el-row :gutter="20" class="slt" :style="{ justifyContent: 'flex-start' }">
        <el-form-item :label="$t('vipUser.userAccount')">
          <el-input v-model="searchForm.zhanghao" :placeholder="$t('vipUser.userAccount')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('vipUser.vipLevel')">
          <el-select v-model="searchForm.vipLevel" :placeholder="$t('vipUser.vipLevel')" clearable>
            <el-option :label="$t('vipUser.silverMember')" value="银卡会员"></el-option>
            <el-option :label="$t('vipUser.goldMember')" value="金卡会员"></el-option>
            <el-option :label="$t('vipUser.diamondMember')" value="钻石会员"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!-- 数据表格 -->
    <div class="table-content">
      <el-table
        :data="dataList"
        border
        stripe
        style="width: 100%"
        v-loading="dataListLoading"
      >
        <el-table-column type="index" :label="$t('table.index')" width="50" align="center"></el-table-column>
        <el-table-column prop="id" :label="$t('vipUser.userId')" width="100" align="center"></el-table-column>
        <el-table-column prop="zhanghao" :label="$t('vipUser.userAccount')" align="center"></el-table-column>
        <el-table-column prop="xingming" :label="$t('userMgmt.name')" align="center"></el-table-column>
        <el-table-column prop="shouji" :label="$t('userMgmt.phone')" align="center"></el-table-column>
        <el-table-column prop="vipLevel" :label="$t('vipUser.vipLevel')" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.vipLevel">{{ scope.row.vipLevel }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="vipExpiry" :label="$t('vipUser.expiryTime')" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.vipExpiry) }}
          </template>
        </el-table-column>
        <el-table-column prop="vipActive" :label="$t('common.status')" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.vipActive ? 'success' : 'danger'">
              {{ scope.row.vipActive ? $t('vipUser.valid') : $t('vipUser.expired') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="yue" :label="$t('vipUser.accountBalance')" align="center">
          <template slot-scope="scope">
            ${{ scope.row.yue }} 
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.actions')" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-if="isAuth('vipyonghu','购买')" type="primary" size="mini" @click="handlePurchase(scope.row)">{{ $t('vipUser.purchaseVip') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页控件 -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="allVipUsers.length"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        zhanghao: '',
        vipLevel: ''
      },
      dataList: [],        // 当前页显示的数据
      allVipUsers: [],     // 所有筛选后的VIP用户
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      
      // 构建查询参数 - 首次加载获取所有用户
      let params = {
        page: 1,
        limit: 1000  // 一次性获取足够多的数据，以便在前端进行分页处理
      };
      
      // 添加筛选条件
      if (this.searchForm.zhanghao) {
        params.zhanghao = "%" + this.searchForm.zhanghao + "%";
      }
      if (this.searchForm.vipLevel) {
        params.vipLevel = this.searchForm.vipLevel;
      }
      
      this.$http({
        url: '/yonghu/page',
        method: 'get',
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log("原始用户数据", data.data);

          // 筛选有VIP信息的用户
          this.allVipUsers = data.data.list.filter(user => {
            // 检查用户是否有VIP等级
            const hasVipLevel = user.vipLevel && user.vipLevel.trim() !== '';
            // 验证用户的VIP状态
            const isVipActive = user.vipActive === true || user.vipActive === 1;
            
            return hasVipLevel && isVipActive;
          });
          
          this.totalPage = this.allVipUsers.length;
          console.log("总VIP用户数:", this.totalPage);
          
          // 处理当前页数据
          this.updateCurrentPageData();
          
        } else {
          this.allVipUsers = [];
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      }).catch(() => {
        this.dataListLoading = false;
        this.$message.error(this.$t('vipUser.getVipUserListFailed'));
      });
    },
    
    // 更新当前页数据
    updateCurrentPageData() {
      const startIndex = (this.pageIndex - 1) * this.pageSize;
      const endIndex = Math.min(startIndex + this.pageSize, this.allVipUsers.length);
      
      this.dataList = this.allVipUsers.slice(startIndex, endIndex);
      console.log(`显示第${startIndex + 1}到${endIndex}条数据，共${this.allVipUsers.length}条`);
    },
    
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.updateCurrentPageData();
    },
    
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.updateCurrentPageData();
    },
    
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        zhanghao: '',
        vipLevel: ''
      };
      this.getDataList();
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString();
    },
    
    // 购买VIP
    handlePurchase(row) {
      this.$router.push({
        path: '/vippurchase',
        query: { zhanghao: row.zhanghao }
      });
    },
    
    // 权限判断
    isAuth(tableName, key) {
      return true; // 默认开放权限，可根据实际需求修改
    },
    
    // 处理搜索
    handleSearch() {
      this.getDataList();
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.form-content {
  margin-bottom: 20px;
}
.slt {
  margin-bottom: 10px;
}
</style> 